import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PropTypes } from 'prop-types';
import { useAppsFeaturesRolesFromAssignedRoles } from '../../../hooks/useAppsFeaturesRolesFromAssignedRoles';
import { ASSIGNED_ROLES_TYPES } from '../../../constants';
import AppSection from '../roles/AppSection';
import { Container, EmptyState } from '../roles/styles';

const PrincipalRoles = ({ principal }) => {
  const { t } = useTranslation();

  const data = useAppsFeaturesRolesFromAssignedRoles(principal?.assignedRoles);

  // Transform the data to match AppSection's expected format
  const transformedApps = useMemo(
    () =>
      data.map(communityApp => ({
        installationTag: communityApp.alias || communityApp.installationName,
        communityTag: communityApp.communityName,
        features: (communityApp.features || []).map(feature => ({
          id: feature.featureTag,
          tag: feature.featureTag,
          name: feature.featureName,
          roles: (feature.roles || []).map(role => {
            const userGroupSources = role.sources?.filter(
              s => s.type === ASSIGNED_ROLES_TYPES.USER_GROUP
            );
            const userGroupsText = userGroupSources?.length
              ? ` (${t('userGroups')}: ${userGroupSources.map(s => s.name).join(', ')})`
              : '';
            return {
              id: role.roleTag,
              name: `${role.roleName}${userGroupsText}`,
            };
          }),
        })),
      })),
    [data, t]
  );

  return (
    <Container>
      {transformedApps.length > 0 ? (
        transformedApps.map((app, index) => (
          <AppSection
            key={`${app.communityTag}_${app.installationTag}_${index}`}
            installationTag={app.installationTag}
            communityTag={app.communityTag}
            features={app.features}
          />
        ))
      ) : (
        <EmptyState>{t('noRolesFound')}</EmptyState>
      )}
    </Container>
  );
};

PrincipalRoles.propTypes = { principal: PropTypes.object };
PrincipalRoles.defaultProps = { principal: {} };

export default PrincipalRoles;
